<template>
<svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M9.2078 3.13292L9.20887 3.13435L10.3755 4.68435L10.3762 4.68521C10.3843 4.69593 10.3926 4.70708 10.4013 4.71859C10.5027 4.85397 10.6408 5.03841 10.8455 5.14601C11.0732 5.26574 11.3291 5.26699 11.55 5.26699H13.875C15.1339 5.26699 16.2562 5.85682 16.9795 6.77854C17.0246 6.836 17.0347 6.88081 17.0358 6.91118C17.037 6.94429 17.028 6.9846 17.0005 7.02858C16.9436 7.11965 16.8154 7.20866 16.6366 7.20866H2.66669C2.39054 7.20866 2.16669 6.9848 2.16669 6.70866V5.35033C2.16669 3.59313 3.59283 2.16699 5.35002 2.16699H7.28335C7.90965 2.16699 8.25845 2.26897 8.49968 2.41006C8.74874 2.55572 8.93915 2.77334 9.2078 3.13292Z" stroke="#"/>
<path d="M17.3201 8.95802C17.871 8.95801 18.3182 9.40367 18.3201 9.95463L18.3334 13.8749C18.3334 16.3332 16.3334 18.3332 13.875 18.3332H6.12502C3.66669 18.3332 1.66669 16.3332 1.66669 13.8749V9.95822C1.66669 9.40594 2.11439 8.95823 2.66667 8.95822L17.3201 8.95802Z"/>
</svg>
</template>
  
<script>
export default {
  name: 'ProjectIcon',
  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    isActive: Boolean,
  },
  data() {
    return {
      
    }
  },
};
</script>
